import React from "react";
import { Link } from "react-router-dom";
import { Modal, MenuItem, NavDropdown } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";

import Button from "../../../../components/common/button/Button";
import Table from "../../../../components/common/table/Table";
import Toast from "../../../../components/common/toast/Toast";

import { PROJECT_INDEX_TABLE } from "../../../../actions/project.actions";

import styles from "./ProjectIndex.scss";

class ProjectIndex extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.show || false,
      selectedProject: null
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen(project) {
    this.setState({ show: true, selectedProject: project });
  }

  handleClose() {
    this.setState({ show: false, selectedProject: null });
  }

  componentDidMount() {
    if (localStorage.getItem("Review:Id")) {
      this.toast.showToast(this.onToastClose);
      localStorage.removeItem("Review:Id");
    }
  }

  render() {
    const mappedRows = Array.from(this.props.projects).map(project => {
      return {
        rowKey: project.id,
        link: `/company/project/${project.id}`,
        data: [
          {
            displayText: (
              <Link
                to={`/company/project/${project.id}`}
                className={styles.projectTitle}
              >
                {project.title}
              </Link>
            ),
            orderByText: project.title
          },
          {
            displayText: this.getStatusText(project.status),
            orderByText: _.get(project, "status.display_name")
          },
          {
            displayText: this.getActivityText(project),
            orderByText: project.updated_at
          }
        ]
      };
    });

    const tableData = {
      headers: [
        {
          displayText: "PROJECT TITLE",
          id: "table-company-projects-sort-title",
          track: "Table - Company Projects - Sort By Project"
        },
        {
          displayText: "STATUS",
          id: "table-company-projects-sort-status",
          track: "Table - Company Projects - Sort By Status"
        },
        {
          displayText: "ACTIVITY",
          id: "table-company-projects-sort-activity",
          track: "Table - Company Projects - Sort By Activity"
        }
      ],
      rows: mappedRows
    };

    return (
      <React.Fragment>
        <Toast
          onRef={ref => (this.toast = ref)}
          title="Thank you."
          content="Your feedback has been submitted."
        />

        <div className={styles.projectIndex}>
          <h2 className={styles.pageTitle}>All Projects</h2>
          <p className={styles.pageSubTitle}>
            Here you’ll find a history of all the projects you’ve created on
            Second Shift. Sort by clicking the column headers. To see matches
            and proposals for a specific project, click on the project title.
          </p>
          <div className={styles.divider}>
            <div className={styles.top} />
            <div className={styles.bottom} />
          </div>

          <Table
            isHoverable
            colsConfig={["40%", "20%", "40%"]}
            name={PROJECT_INDEX_TABLE}
            tableData={tableData}
          />
        </div>

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          dialogClassName={styles.modalContainer}
        >
          <Modal.Body className={styles.modalBody}>
            <div className={styles.title}>
              Are you sure you want to remove this project?
            </div>
            <div className={styles.body}>
              You will not have access this this project again.
            </div>
            <div className={styles.dividerDouble} />

            <div className={styles.CTAContainer}>
              <div className={styles.option}>
                <Button
                  isPrimary
                  label="Yes, Remove It From My Projects List"
                  onClick={() => {
                    this.props.hideProject(this.state.selectedProject.id);
                    this.handleClose();
                  }}
                />
              </div>

              <div className={styles.option}>
                <a className={styles.link} onClick={() => this.handleClose()}>
                  Cancel
                </a>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }

  getStatusText(status) {
    const draftComponent = (
      <div className={styles.greyText}>DRAFT - Not Posted</div>
    );

    let out = _.get(status, "display_name");

    if (_.get(status, "name") === "draft") out = draftComponent;

    if (_.get(status, "name") === "rejected") out = "Declined";

    return out;
  }

  getActivityText(project) {
    const { id, updated_at, status } = project;
    const updateAt = moment(updated_at, "YYYY-MM-DD HH:mm:ss").format(
      "MM/DD/YYYY"
    );

    const statusName = _.get(status, "name");

    const draftComponent = (
      <div className={styles.activity}>
        <span className={styles.activityText}>Saved on {updateAt}</span>
        <NavDropdown
          id="actions"
          title="ACTIONS"
          className={styles.dropdownMenuButton}
          onClick={e => e.stopPropagation()}
        >
          <MenuItem
            id="action-edit"
            className={styles.dropdownItem}
            onClick={e => {
              e.stopPropagation();
              this.props.editProject(id);
            }}
          >
            Edit Draft
          </MenuItem>
          <MenuItem
            id="actions-remove"
            className={styles.dropdownItem}
            onClick={e => {
              e.stopPropagation();
              this.handleOpen(project);
            }}
          >
            Remove Project
          </MenuItem>
        </NavDropdown>
      </div>
    );

    const submittedForApprovalComponent = (
      <div className={styles.activity}>
        <span className={styles.activityText}>Saved on {updateAt}</span>
        <button
          className={styles.activityButton}
          onClick={e => {
            e.stopPropagation();
            this.props.editProject(id);
          }}
        >
          Edit Draft
        </button>
      </div>
    );

    const removeComponent = (
      <div className={styles.activity}>
        <span className={styles.activityText}>Rejected on {updateAt}</span>
        <button
          className={styles.activityButton}
          onClick={e => {
            e.stopPropagation();
            this.handleOpen(project);
          }}
        >
          Remove Project
        </button>
      </div>
    );

    const sowComponent = (
      <div className={styles.activity}>
        <span className={styles.activityText}>{updateAt}</span>
        <button
          className={styles.activityButton}
          onClick={e => {
            e.stopPropagation();
            this.props.viewSOW(project);
          }}
        >
          View SOW
        </button>
      </div>
    );

    switch (statusName) {
      case "draft":
        return draftComponent;
      case "submitted-for-approval":
        return submittedForApprovalComponent;
      case "rejected":
        return removeComponent;
      case "sow":
      case "in-progress":
        return sowComponent;
      default:
        return updateAt;
    }
  }
}

export default ProjectIndex;



// WEBPACK FOOTER //
// ./src/routes/employer/projectIndex/components/ProjectIndex.js